import Angular from "angular";
import Controller from "./search.controller";
import Template from "./search.html";
import Search from "../../components/search/search";

export const SearchView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.search', [
    Search.name
]);




// WEBPACK FOOTER //
// ./src/modules/main/views/search/search.js